import { useEffect } from 'react'

import type { VirtualAssistantChatPanelState } from '@features/virtualAssistant'

// Keeps the --drawer-border-radius CSS variable in sync with drawer open/closed state.
// Ember views and the nav sidebar read this variable to apply matching rounded corners.
const DRAWER_BORDER_RADIUS_CSS_VAR = '--drawer-border-radius'

interface DrawerBorderRadiusSyncProps {
  chatPanelState: VirtualAssistantChatPanelState
}

export const DrawerBorderRadiusSync = ({ chatPanelState }: DrawerBorderRadiusSyncProps): null => {
  const { isOpen } = chatPanelState
  useEffect(() => {
    document.documentElement.style.setProperty(DRAWER_BORDER_RADIUS_CSS_VAR, isOpen ? '16px' : '0px')
    return () => {
      document.documentElement.style.setProperty(DRAWER_BORDER_RADIUS_CSS_VAR, '0px')
    }
  }, [isOpen])
  return null
}
